export const doctorInfo = {
  name: "Dr. Venkata Pradeep Babu Koyyala",
  title: "Medical Oncologist",
  credentials: "DrNB Medical Oncology, MD General Medicine, MBA Hospital Administration",
  currentPosition: "Director & CEO, Shankara Cancer and Research Institute, Tezpur",
  leadershipRoles: [
    "EC Member, ISMPO (Indian Society of Medical and Pediatric Oncologists)",
    "Executive Secretary, NESMO (North East Society of Medical and Pediatric Oncologists)"
  ],
  photo: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png",
  tagline: "Dedicated to providing world-class cancer care with compassion and expertise",
  about: {
    summary: "Dr. Venkata Pradeep Babu Koyyala is a highly accomplished Medical Oncologist with extensive international training and over 112 published research papers. As the Director and CEO of Shankara Cancer and Research Institute, Tezpur, he brings cutting-edge cancer treatment to Northeast India. His patient-centric approach combines evidence-based medicine with compassionate care.",
    experience: "With comprehensive training from prestigious institutions including ESMO (European Society for Medical Oncology), Princess Margaret Cancer Center Toronto, and multiple international fellowships, Dr. Koyyala specializes in Breast Cancer, Immuno-Oncology, and Molecular Oncology. He has successfully treated thousands of cancer patients with a holistic approach that integrates modern oncology with palliative care.",
    philosophy: "My objective is to do the best in the Patient Interest within available Resources and to stay updated on recent developments in Oncology. I focus on Prevention, Early Detection, Curative Treatment, and Palliative Care."
  },
  contact: {
    email: "pradeepbabu.koyyala@gmail.com",
    whatsapp: "+91 8099001565",
    location: "Shankara Cancer and Research Institute, Tezpur, Assam, India"
  }
};

export const expertise = [
  {
    id: 1,
    title: "Breast Cancer",
    description: "Comprehensive management including chemotherapy, targeted therapy, and immunotherapy. Specialized training from ESMO and international centers.",
    icon: "Heart"
  },
  {
    id: 2,
    title: "Immuno-Oncology",
    description: "Advanced immunotherapy treatments for various cancers. ESMO-certified with specialized preceptorship training.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Lung Cancer",
    description: "Early detection and comprehensive treatment including targeted therapies. Leading AI-based early nodal detection project.",
    icon: "Wind"
  },
  {
    id: 4,
    title: "Gastrointestinal Cancers",
    description: "Expert management of colorectal, stomach, and other GI malignancies with molecular oncology expertise.",
    icon: "Activity"
  },
  {
    id: 5,
    title: "Gynecological Cancers",
    description: "Specialized care for ovarian, cervical, and uterine cancers with multidisciplinary approach.",
    icon: "Users"
  },
  {
    id: 6,
    title: "Palliative Care",
    description: "Integrated oncology and palliative care approach. Trained at Princess Margaret Cancer Center, Toronto.",
    icon: "HeartHandshake"
  }
];

export const achievements = [
  {
    id: 1,
    year: "Current",
    title: "Executive Secretary, NESMO",
    description: "North East Society of Medical and Pediatric Oncologists - Leading oncology advancement in Northeast India",
    category: "Leadership"
  },
  {
    id: 2,
    year: "Current",
    title: "EC Member, ISMPO",
    description: "Indian Society of Medical and Pediatric Oncologists - Executive Committee Member",
    category: "Leadership"
  },
  {
    id: 3,
    year: "2023",
    title: "MINA BHUYAN FOUNDATION AWARD",
    description: "Prestigious award for People Friendly Doctor in Assam",
    category: "Award"
  },
  {
    id: 4,
    year: "2022",
    title: "ESMO International Mentorship Program",
    description: "Completed mentorship under Dr Peter Vuylsteke, Netherlands",
    category: "Fellowship"
  },
  {
    id: 5,
    year: "2020",
    title: "ESMO Developing Nations Abstract Award",
    description: "22nd World Congress on Gastrointestinal Cancer, Barcelona, Spain",
    category: "Award"
  },
  {
    id: 6,
    year: "2019",
    title: "ESMO Community Session Award",
    description: "6th ESMO Integrated Oncology & Palliative Care Community Session",
    category: "Award"
  },
  {
    id: 7,
    year: "2019",
    title: "Winner - Overall Championship Trophy",
    description: "GOLD MEDAL in Complicated Case Capsules Discussion",
    category: "Competition"
  },
  {
    id: 8,
    year: "2019",
    title: "Best E-Poster & Oral Presentation",
    description: "Prognostic Role of Circulating Tumor Cells in Metastatic Breast Cancer",
    category: "Research"
  }
];

export const education = [
  {
    id: 1,
    year: "2016-2019",
    degree: "DrNB Medical Oncology",
    institution: "Rajiv Gandhi Cancer Institute and Research Center, New Delhi",
    description: "Doctorate in National Board Medical Oncology"
  },
  {
    id: 2,
    year: "2012-2015",
    degree: "MD General Medicine",
    institution: "Dr. PSIMS & RF, Gannavaram, Andhra Pradesh",
    description: "Postgraduate medical training in Internal Medicine"
  },
  {
    id: 3,
    year: "2019",
    degree: "ESMO Community Fellowship",
    institution: "Princess Margaret Cancer Center, Toronto, Canada",
    description: "Integrated Oncology and Palliative Care"
  },
  {
    id: 4,
    year: "2022",
    degree: "ECMO Certification",
    institution: "European Society for Medical Oncology, Barcelona",
    description: "European Society Certification in Medical Oncology"
  },
  {
    id: 5,
    year: "2004-2010",
    degree: "MBBS",
    institution: "Andhra Medical College and King George Hospital, Visakhapatnam",
    description: "Bachelor of Medicine and Bachelor of Surgery"
  }
];

export const publications = [
  {
    id: 1,
    title: "Over 112 Published Papers and Case Reports",
    description: "Extensive research contributions in various oncology journals",
    type: "Research"
  },
  {
    id: 2,
    title: "Clinical Oncology – VIVA VOCE, OSCES and ESMO Exam Compendium",
    description: "Editor and Author of comprehensive book for oncology students",
    type: "Book"
  },
  {
    id: 3,
    title: "12 Review Articles",
    description: "Comprehensive reviews in leading medical journals",
    type: "Review"
  },
  {
    id: 4,
    title: "Textbook Chapter",
    description: "Contributed chapter in oncology textbook",
    type: "Chapter"
  }
];

export const affiliations = [
  "European Society for Medical Oncology (ESMO)",
  "American Society of Clinical Oncology (ASCO)",
  "Indian Society of Medical and Pediatric Oncologists (ISMPO)",
  "International Association for the Study of Lung Cancer (IASLC)",
  "Society for Immunotherapy for Cancer (SITC)",
  "Union International for Cancer Control (UICC)",
  "Society International for Geriatric Oncology (SIOG)",
  "European Society of Gynecologic Oncology (ESGO)",
  "Asian-Pacific Hepato-Pancreato-Biliary Association",
  "Indian Council of Medical Research (ICMR)"
];

export const projects = [
  {
    id: 1,
    name: "PROJECT SMART PINK",
    description: "Initiative to screen 1000 women by mammography and Thermalytix through Rotary Club of Tezpur",
    role: "Project Chair",
    impact: "Early breast cancer detection in community"
  },
  {
    id: 2,
    name: "PROJECT SOUNDARYA",
    description: "Donor-funded initiative providing hair wigs for women losing hair during chemotherapy",
    role: "Project Head",
    impact: "Improving quality of life for cancer patients"
  },
  {
    id: 3,
    name: "PROJECT ANNAPURNA",
    description: "Crowd-funded project to provide soft diet to cancer patients and their attendants",
    role: "Project Lead",
    impact: "Nutritional support for patients undergoing treatment"
  },
  {
    id: 4,
    name: "AI-based Lung Cancer Early Detection",
    description: "Early Nodule Detection (E.N.D.) under Lung Ambition Alliance with AstraZeneca",
    role: "Principal Investigator",
    impact: "Advanced early detection technology"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Immunotherapy in Cancer Treatment",
    excerpt: "Immunotherapy has revolutionized cancer treatment by harnessing the body's immune system to fight cancer cells. Learn about the latest advances...",
    date: "2024-01-15",
    category: "Treatment",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "Early Detection Saves Lives: Breast Cancer Screening",
    excerpt: "PROJECT SMART PINK aims to screen 1000 women for breast cancer. Understanding the importance of early detection and screening methods...",
    date: "2024-01-08",
    category: "Prevention",
    readTime: "4 min read"
  },
  {
    id: 3,
    title: "The Role of Palliative Care in Cancer Treatment",
    excerpt: "Integrating palliative care with oncology treatment improves patient quality of life. Insights from my fellowship at Princess Margaret Cancer Center...",
    date: "2023-12-20",
    category: "Care",
    readTime: "6 min read"
  }
];

export const internationalConferences = [
  {
    id: 1,
    name: "Dhaka Cancer Summit",
    country: "Bangladesh",
    location: "Dhaka",
    date: "Recent",
    role: "Keynote Speaker",
    description: "Invited as keynote speaker to share insights on modern cancer treatment approaches and oncology practices",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png"
    ]
  },
  {
    id: 2,
    name: "SAARC Oncology Conference",
    country: "Nepal",
    location: "Kathmandu",
    date: "Recent",
    role: "Speaker",
    description: "Presented at prestigious SAARC regional oncology conference bringing together experts from South Asian countries",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png"
    ]
  },
  {
    id: 3,
    name: "Malaysian Cancer Congress",
    country: "Malaysia",
    location: "Johor Bahru",
    date: "Recent",
    role: "Guest Speaker - Next Generation Sequencing",
    description: "Invited as guest speaker to present on Next Generation Sequencing in cancer diagnosis and personalized treatment",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png"
    ]
  },
  {
    id: 4,
    name: "Short Term Training Program",
    country: "Singapore",
    location: "National University of Singapore (NUS)",
    date: "2019",
    role: "Clinical Training Participant",
    description: "Advanced short-term clinical training in medical oncology at premier institution",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png"
    ]
  },
  {
    id: 5,
    name: "ESMO Academy Medical Oncology Training",
    country: "United Kingdom",
    location: "Oxford University",
    date: "August 2019",
    role: "ESMO Academy Participant",
    description: "Comprehensive medical oncology training at Oxford University through prestigious ESMO Academy program",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png"
    ]
  },
  {
    id: 6,
    name: "ESMO Short Term Fellowship - Integrative Oncology",
    country: "Canada",
    location: "Princess Margaret Cancer Centre, Toronto",
    date: "October-November 2019",
    role: "ESMO Short-term Fellow",
    description: "Intensive fellowship in integrative oncology and palliative care at world-renowned Princess Margaret Cancer Center",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png"
    ]
  },
  {
    id: 7,
    name: "UICC Fellowship - Molecular Oncology",
    country: "Italy",
    location: "University of Campania Luigi Vanvitelli, Naples",
    date: "December 2020",
    role: "Visiting Fellow",
    description: "Specialized training in molecular oncology of colorectal cancers under mentorship of Dr. Antonio Galvano",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png"
    ]
  },
  {
    id: 8,
    name: "22nd ESMO World Congress on Gastrointestinal Cancer",
    country: "Spain",
    location: "Barcelona",
    date: "2020",
    role: "Developing Nations Abstract Award Winner",
    description: "Presented research and received prestigious award at international GI cancer conference",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png"
    ]
  },
  {
    id: 9,
    name: "ESMO International Mentorship Program",
    country: "Netherlands",
    location: "Mentorship under Dr. Peter Vuylsteke",
    date: "2022",
    role: "International Mentee",
    description: "Completed prestigious international mentorship program with leading European oncologist",
    images: [
      "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png"
    ]
  }
];

export const communityProjects = [
  {
    id: 1,
    name: "Ashadeep",
    tagline: "A Home Away from Home",
    description: "Free accommodation and food for cancer patients traveling long distances to Tezpur for treatment. Providing comfort and support during the most challenging times.",
    impact: "Hundreds of families supported annually",
    type: "Accommodation & Support",
    icon: "Home",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png",
    link: null
  },
  {
    id: 2,
    name: "Project ANNAPURNA",
    tagline: "Nourishing Hope",
    description: "Community-led initiative providing free soft diet to cancer patients and their attendants during treatment. Ensuring proper nutrition for better recovery.",
    impact: "Thousands of meals served",
    type: "Nutritional Support",
    icon: "Utensils",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png",
    link: null
  },
  {
    id: 3,
    name: "Project SMART PINK",
    tagline: "Early Detection Saves Lives",
    description: "Mammography screening initiative led in collaboration with ACCF and Rotary Club of Tezpur. Screening 1000 women using mammography and Thermalytix technology.",
    impact: "1000+ women screened",
    type: "Breast Cancer Screening",
    icon: "Heart",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png",
    link: null
  },
  {
    id: 4,
    name: "Project ENIGMA",
    tagline: "Precision Medicine for Northeast",
    description: "Collaborative project with Karkinos Healthcare to evaluate combined germline and somatic sequencing in young breast cancer patients in Northeast India. Bringing precision oncology to the region.",
    impact: "Advancing personalized cancer care",
    type: "Research & Innovation",
    icon: "Microscope",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png",
    link: null
  },
  {
    id: 5,
    name: "Project SOUNDARYA",
    tagline: "Restoring Confidence",
    description: "CSR-funded initiative providing hair wigs for women and men experiencing hair loss during chemotherapy. Helping patients maintain dignity and confidence.",
    impact: "Hundreds of wigs provided",
    type: "Patient Support",
    icon: "Smile",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png",
    link: null
  },
  {
    id: 6,
    name: "Project GENESIS",
    tagline: "Understanding Hereditary Cancer",
    description: "Germline evaluation in cancer patients to identify hereditary cancer syndromes and enable preventive strategies for families at risk.",
    impact: "Identifying hereditary cancer risks",
    type: "Genetic Counseling",
    icon: "Dna",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png",
    link: null
  },
  {
    id: 7,
    name: "Viswapragna Foundation",
    tagline: "Empowering Through Knowledge",
    description: "Founded Viswapragna Foundation to provide education, awareness, and support for cancer and autism. A platform for community engagement and social impact.",
    impact: "State-wide reach & impact",
    type: "NGO Foundation",
    icon: "Building",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png",
    link: "https://www.viswapragnafoundation.org"
  },
  {
    id: 8,
    name: "NECAP 2025",
    tagline: "Breaking Myths, Building Awareness",
    description: "State-level awareness campaign on cancer and autism. Educational programs breaking myths and providing scientific information to communities across Assam.",
    impact: "Thousands reached across Assam",
    type: "Public Awareness Campaign",
    icon: "Megaphone",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png",
    link: "https://viswapragnafoundation.org/event/necap-2025/"
  },
  {
    id: 9,
    name: "Community Awareness Camps",
    tagline: "Taking Healthcare to the People",
    description: "Regular awareness camps in villages, tribal areas, schools, and colleges across Assam and Nagaland. Educating communities about cancer prevention, early detection, and treatment options.",
    impact: "Hundreds of camps conducted",
    type: "Grassroots Outreach",
    icon: "Users",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png",
    link: null
  }
];

export const nationalConferences = [
  {
    id: 1,
    name: "National Conference Name 1",
    location: "City, India",
    date: "Year",
    description: "Brief description of your participation or presentation",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png"
  },
  {
    id: 2,
    name: "National Conference Name 2",
    location: "City, India",
    date: "Year",
    description: "Brief description of your participation or presentation",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png"
  },
  {
    id: 3,
    name: "National Conference Name 3",
    location: "City, India",
    date: "Year",
    description: "Brief description of your participation or presentation",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png"
  },
  {
    id: 4,
    name: "National Conference Name 4",
    location: "City, India",
    date: "Year",
    description: "Brief description of your participation or presentation",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png"
  },
  {
    id: 5,
    name: "National Conference Name 5",
    location: "City, India",
    date: "Year",
    description: "Brief description of your participation or presentation",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/f0bkr4yp_Gemini_Generated_Image_a17t0oa17t0oa17t.png"
  },
  {
    id: 6,
    name: "National Conference Name 6",
    location: "City, India",
    date: "Year",
    description: "Brief description of your participation or presentation",
    image: "https://customer-assets.emergentagent.com/job_cancer-care-expert/artifacts/93mzh5n9_Gemini_Generated_Image_4q3zsa4q3zsa4q3z.png"
  }
];

export const conferences = internationalConferences;

export const testimonials = [
  {
    id: 1,
    name: "Patient Family",
    text: "Dr. Koyyala's compassionate approach and expertise gave us hope during the most difficult time. His clear explanations and dedication to patient care are remarkable.",
    treatment: "Breast Cancer Treatment"
  },
  {
    id: 2,
    name: "Medical Professional",
    text: "Dr. Koyyala's extensive research and international training make him one of the leading oncologists in Northeast India. His commitment to bringing world-class care is commendable.",
    treatment: "Colleague"
  },
  {
    id: 3,
    name: "Patient",
    text: "The care and attention I received was exceptional. Dr. Koyyala took time to explain every step of the treatment and made sure I was comfortable throughout the process.",
    treatment: "Lung Cancer Treatment"
  }
];